export const handleValidation = (email, ticketId) => {
    validateTicket(ticketId);
};

const validateTicket = (ticketId) => {
    if (!ticketId) throw "Please select a ticket";
};